module.exports = __webpack_public_path__ + "img/2024121002.180639b5.png";